import { Button, ButtonProps, ConfigProvider, theme } from 'antd';
import { FC, memo } from 'react';

type Props = ButtonProps & object;

export const ButtonSuccess: FC<Props> = memo(({ children, ...otherProps }) => {
  const { token } = theme.useToken();

  return (
    <ConfigProvider theme={{ token: { colorPrimary: token['green-6'] } }}>
      <Button { ...otherProps }>{ children }</Button>
    </ConfigProvider>
  );
});
